

import React, { useState } from 'react';
import { 
  Search, Filter, Download, Eye, Edit, Trash2, 
  Plus, Star, TrendingUp, Users, DollarSign,
  Briefcase, X, Save, Image, Tag, FileText,
  AlertCircle, Check, ToggleLeft, ToggleRight,
  Clock, Calendar, MapPin, Award
} from 'lucide-react';
import '../../../../assets/css/screens/admin/dashboard/adminservices/AdminServices.css';

const AdminServices = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  // Service form state
  const [serviceForm, setServiceForm] = useState({
    name: '',
    category: '',
    description: '',
    basePrice: '',
    priceUnit: 'hour',
    duration: '',
    image: null,
    featured: false,
    status: 'active'
  });

  // Stats Data
  const serviceStats = [
    {
      id: 1,
      title: 'Total Services',
      value: '24',
      change: '+3 new this month',
      icon: Briefcase,
      color: '#484745',
      trend: 'up'
    },
    {
      id: 2,
      title: 'Active Services',
      value: '18',
      change: '75% active rate',
      icon: ToggleRight,
      color: '#10b981',
      trend: 'up'
    },
    {
      id: 3,
      title: 'Total Bookings',
      value: '3,456',
      change: '+234 this week',
      icon: Calendar,
      color: '#3b82f6',
      trend: 'up'
    },
    {
      id: 4,
      title: 'Revenue',
      value: 'Rs 2.4M',
      change: '+12% this month',
      icon: DollarSign,
      color: '#f59e0b',
      trend: 'up'
    }
  ];

  // Services Data
  const [services, setServices] = useState([
    {
      id: 1,
      name: 'Electrical Wiring & Repair',
      category: 'Electrical',
      description: 'Professional electrical wiring, repairs, and installations for homes and offices.',
      basePrice: 800,
      priceUnit: 'hour',
      duration: '2-3 hours',
      totalBookings: 456,
      activeProviders: 45,
      rating: 4.8,
      reviews: 234,
      revenue: 364800,
      featured: true,
      status: 'active',
      image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=300&h=200&fit=crop',
      createdAt: '2024-01-15'
    },
    {
      id: 2,
      name: 'Plumbing Services',
      category: 'Plumbing',
      description: 'Expert plumbing solutions including pipe repairs, installations, and maintenance.',
      basePrice: 600,
      priceUnit: 'hour',
      duration: '1-2 hours',
      totalBookings: 589,
      activeProviders: 38,
      rating: 4.7,
      reviews: 312,
      revenue: 353400,
      featured: true,
      status: 'active',
      image: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?w=300&h=200&fit=crop',
      createdAt: '2024-01-20'
    },
    {
      id: 3,
      name: 'House Cleaning',
      category: 'Cleaning',
      description: 'Thorough house cleaning services including deep cleaning and maintenance.',
      basePrice: 350,
      priceUnit: 'hour',
      duration: '3-4 hours',
      totalBookings: 723,
      activeProviders: 67,
      rating: 4.9,
      reviews: 456,
      revenue: 253050,
      featured: true,
      status: 'active',
      image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=300&h=200&fit=crop',
      createdAt: '2024-02-01'
    },
    {
      id: 4,
      name: 'AC Repair & Maintenance',
      category: 'HVAC',
      description: 'Air conditioning repair, maintenance, and installation services.',
      basePrice: 700,
      priceUnit: 'hour',
      duration: '2-3 hours',
      totalBookings: 298,
      activeProviders: 23,
      rating: 4.6,
      reviews: 178,
      revenue: 208600,
      featured: false,
      status: 'active',
      image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300&h=200&fit=crop',
      createdAt: '2024-02-10'
    },
    {
      id: 5,
      name: 'Home Painting',
      category: 'Painting',
      description: 'Professional interior and exterior painting services for homes and offices.',
      basePrice: 550,
      priceUnit: 'hour',
      duration: '4-6 hours',
      totalBookings: 167,
      activeProviders: 29,
      rating: 4.5,
      reviews: 98,
      revenue: 91850,
      featured: false,
      status: 'active',
      image: 'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=300&h=200&fit=crop',
      createdAt: '2024-03-05'
    },
    {
      id: 6,
      name: 'Cooking Services',
      category: 'Cook',
      description: 'Professional cooking services for events, parties, and daily meals.',
      basePrice: 450,
      priceUnit: 'hour',
      duration: '2-4 hours',
      totalBookings: 234,
      activeProviders: 34,
      rating: 4.7,
      reviews: 145,
      revenue: 105300,
      featured: false,
      status: 'inactive',
      image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=300&h=200&fit=crop',
      createdAt: '2024-03-15'
    }
  ]);

  // Handle Create Service
  const handleCreateService = () => {
    setShowCreateModal(true);
    setServiceForm({
      name: '',
      category: '',
      description: '',
      basePrice: '',
      priceUnit: 'hour',
      duration: '',
      image: null,
      featured: false,
      status: 'active'
    });
  };

  // Handle Edit Service
  const handleEditService = (service) => {
    setSelectedService(service);
    setServiceForm({
      name: service.name,
      category: service.category,
      description: service.description,
      // basePrice: service.basePrice,
      // priceUnit: service.priceUnit,
      // duration: service.duration,
      image: service.image,
      featured: service.featured,
      status: service.status
    });
    setShowEditModal(true);
  };

  // Handle View Service
  const handleViewService = (service) => {
    setSelectedService(service);
    setShowViewModal(true);
  };

  // Handle Delete Service
  const handleDeleteService = (service) => {
    setSelectedService(service);
    setShowDeleteModal(true);
  };

  // Confirm Delete
  const confirmDelete = () => {
    setServices(services.filter(s => s.id !== selectedService.id));
    setShowDeleteModal(false);
    setSelectedService(null);
    alert('Service deleted successfully!');
  };

  // Toggle Service Status
  const toggleServiceStatus = (service) => {
    setServices(services.map(s => 
      s.id === service.id 
        ? { ...s, status: s.status === 'active' ? 'inactive' : 'active' }
        : s
    ));
    alert(`Service ${service.status === 'active' ? 'deactivated' : 'activated'} successfully!`);
  };

  // Toggle Featured
  const toggleFeatured = (service) => {
    setServices(services.map(s => 
      s.id === service.id 
        ? { ...s, featured: !s.featured }
        : s
    ));
  };

  // Save Service (Create or Edit)
  const saveService = (e) => {
    e.preventDefault();
    
    if (showEditModal) {
      // Update existing service
      setServices(services.map(s => 
        s.id === selectedService.id 
          ? { 
              ...s, 
              ...serviceForm,
              basePrice: parseFloat(serviceForm.basePrice)
            }
          : s
      ));
      alert('Service updated successfully!');
      setShowEditModal(false);
    } else {
      // Create new service
      const newService = {
        id: services.length + 1,
        ...serviceForm,
        basePrice: parseFloat(serviceForm.basePrice),
        totalBookings: 0,
        activeProviders: 0,
        rating: 0,
        reviews: 0,
        revenue: 0,
        createdAt: new Date().toISOString().split('T')[0]
      };
      setServices([newService, ...services]);
      alert('Service created successfully!');
      setShowCreateModal(false);
    }
    
    setServiceForm({
      name: '',
      category: '',
      description: '',
      // basePrice: '',
      // priceUnit: 'hour',
      // duration: '',
      image: null,
      featured: false,
      status: 'active'
    });
  };

  // Handle form change
  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setServiceForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setServiceForm(prev => ({
          ...prev,
          image: reader.result
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  // Export to CSV
  const handleExport = () => {
    const csvContent = [
      ['Name', 'Category', 'Base Price', 'Bookings', 'Providers', 'Rating', 'Revenue', 'Status'],
      ...filteredServices.map(s => [
        s.name, s.category, s.basePrice, s.totalBookings, 
        s.activeProviders, s.rating, s.revenue, s.status
      ])
    ].map(row => row.join(',')).join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'services.csv';
    a.click();
  };

  // Filter Services
  const filteredServices = services.filter(service => {
    const matchesSearch = service.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         service.category.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'all' || service.category.toLowerCase() === filterCategory.toLowerCase();
    const matchesStatus = filterStatus === 'all' || service.status === filterStatus;
    return matchesSearch && matchesCategory && matchesStatus;
  });

  // Pagination
  const servicesPerPage = 6;
  const totalPages = Math.ceil(filteredServices.length / servicesPerPage);
  const indexOfLastService = currentPage * servicesPerPage;
  const indexOfFirstService = indexOfLastService - servicesPerPage;
  const currentServices = filteredServices.slice(indexOfFirstService, indexOfLastService);

  return (
    <div className="admin-services-page">
      {/* Page Header */}
      <div className="admin-services-header">
        <div>
          <h1 className="admin-page-title">Services Management</h1>
          <p className="admin-page-subtitle">Manage all services offered on the platform</p>
        </div>
        <div className="header-actions">
          {/* <button className="admin-export-btn" onClick={handleExport}>
            <Download size={20} />
            Export Data
          </button> */}
          <button className="admin-add-service-btn" onClick={handleCreateService}>
            <Plus size={20} />
            Add New Service
          </button>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="admin-service-stats-grid">
        {serviceStats.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.id} className="admin-service-stat-card">
              <div className="admin-stat-icon" style={{ background: stat.color }}>
                <Icon size={24} />
              </div>
              <div className="admin-stat-content">
                <p className="admin-stat-label">{stat.title}</p>
                <h3 className="admin-stat-value">{stat.value}</h3>
                <span className={`admin-stat-change ${stat.trend}`}>
                  {stat.trend === 'up' && <TrendingUp size={14} />}
                  {stat.change}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Filters */}
      <div className="admin-services-filters">
        <div className="admin-search-box">
          <Search size={20} />
          <input
            type="text"
            placeholder="Search services by name or category..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <div className="admin-filter-group">
          <Filter size={18} />
          <select value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)}>
            <option value="all">All Categories</option>
            <option value="electrical">Electrical</option>
            <option value="plumbing">Plumbing</option>
            <option value="cleaning">Cleaning</option>
            <option value="hvac">HVAC</option>
            <option value="painting">Painting</option>
            <option value="cook">Cook</option>
          </select>
        </div>

        <div className="admin-filter-group">
          <ToggleRight size={18} />
          <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            <option value="all">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>

      {/* Services Grid */}
      <div className="admin-services-grid">
        {currentServices.length > 0 ? (
          currentServices.map((service) => (
            <div key={service.id} className="admin-service-card">
              <div className="service-card-image" onClick={() => handleViewService(service)}>
                <img src={service.image} alt={service.name} />
                {/* {service.featured && (
                  <span className="featured-badge">
                    <Star size={12} fill="#fff" />
                    Featured
                  </span>
                )} */}
                <span className={`service-status-badge ${service.status}`}>
                  {service.status === 'active' ? (
                    <ToggleRight size={14} />
                  ) : (
                    <ToggleLeft size={14} />
                  )}
                  {service.status}
                </span>
              </div>

              <div className="service-card-content">
                <div className="service-card-header">
                  <h3 className="service-name" onClick={() => handleViewService(service)}>
                    {service.name}
                  </h3>
                  <span className="service-category-tag">{service.category}</span>
                </div>

                <p className="service-description">{service.description}</p>

                {/* <div className="service-stats-row">
                  <div className="service-stat-item">
                    <Calendar size={14} />
                    <span>{service.totalBookings} bookings</span>
                  </div>
                  <div className="service-stat-item">
                    <Users size={14} />
                    <span>{service.activeProviders} providers</span>
                  </div>
                </div> */}

                {/* <div className="service-rating-row">
                  <div className="service-rating">
                    <Star size={14} fill="#fbbf24" color="#fbbf24" />
                    {service.rating} ({service.reviews} reviews)
                  </div>
                  <div className="service-price">
                    Rs {service.basePrice}/{service.priceUnit}
                  </div>
                </div> */}

                {/* <div className="service-revenue">
                  <DollarSign size={14} />
                  Total Revenue: Rs {service.revenue.toLocaleString()}
                </div> */}

                <div className="service-card-actions">
                  <button 
                    className="service-action-btn view"
                    onClick={() => handleViewService(service)}
                    title="View Details"
                  >
                    <Eye size={16} />
                    View
                  </button>
                  <button 
                    className="service-action-btn edit"
                    onClick={() => handleEditService(service)}
                    title="Edit Service"
                  >
                    <Edit size={16} />
                    Edit
                  </button>
                  <button 
                    className={`service-action-btn toggle ${service.status === 'active' ? 'active' : 'inactive'}`}
                    onClick={() => toggleServiceStatus(service)}
                    title={service.status === 'active' ? 'Deactivate' : 'Activate'}
                  >
                    {service.status === 'active' ? (
                      <><ToggleRight size={16} /> Active</>
                    ) : (
                      <><ToggleLeft size={16} /> Inactive</>
                    )}
                  </button>
                  <button 
                    className="service-action-btn delete"
                    onClick={() => handleDeleteService(service)}
                    title="Delete Service"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-services-found">
            <AlertCircle size={48} />
            <p>No services found matching your criteria.</p>
          </div>
        )}
      </div>

      {/* Pagination */}
      {filteredServices.length > servicesPerPage && (
        <div className="admin-pagination">
          <button 
            className="page-btn" 
            onClick={() => setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button 
              key={index + 1}
              className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button 
            className="page-btn" 
            onClick={() => setCurrentPage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}

      {/* Create/Edit Service Modal */}
      {(showCreateModal || showEditModal) && (
        <div className="admin-modal-overlay" onClick={() => {
          setShowCreateModal(false);
          setShowEditModal(false);
        }}>
          <div className="admin-service-modal" onClick={(e) => e.stopPropagation()}>
            <div className="service-modal-header">
              <h2>{showEditModal ? 'Edit Service' : 'Create New Service'}</h2>
              <button 
                className="modal-close-btn"
                onClick={() => {
                  setShowCreateModal(false);
                  setShowEditModal(false);
                }}
              >
                <X size={24} />
              </button>
            </div>

            <form onSubmit={saveService} className="service-form">
              <div className="service-form-group">
                <label>
                  <FileText size={18} />
                  Service Name *
                </label>
                <input
                  type="text"
                  name="name"
                  value={serviceForm.name}
                  onChange={handleFormChange}
                  placeholder="Enter service name..."
                  required
                />
              </div>

              <div className="service-form-row">
                <div className="service-form-group">
                  <label>
                    <Tag size={18} />
                    Category *
                  </label>
                  <select
                    name="category"
                    value={serviceForm.category}
                    onChange={handleFormChange}
                    required
                  >
                    <option value="">Select Category</option>
                    <option value="Electrical">Electrical</option>
                    <option value="Plumbing">Plumbing</option>
                    <option value="Cleaning">Cleaning</option>
                    <option value="HVAC">HVAC</option>
                    <option value="Painting">Painting</option>
                    <option value="Cook">Cook</option>
                  </select>
                </div>

                {/* <div className="service-form-group">
                  <label>
                    <Clock size={18} />
                    Duration *
                  </label>
                  <input
                    type="text"
                    name="duration"
                    value={serviceForm.duration}
                    onChange={handleFormChange}
                    placeholder="e.g., 2-3 hours"
                    required
                  />
                </div> */}
              </div>

              <div className="service-form-group">
                <label>
                  <FileText size={18} />
                  Description *
                </label>
                <textarea
                  name="description"
                  value={serviceForm.description}
                  onChange={handleFormChange}
                  placeholder="Enter service description..."
                  rows="3"
                  required
                ></textarea>
              </div>

              {/* <div className="service-form-row">
                <div className="service-form-group">
                  <label>
                    <DollarSign size={18} />
                    Base Price (Rs) *
                  </label>
                  <input
                    type="number"
                    name="basePrice"
                    value={serviceForm.basePrice}
                    onChange={handleFormChange}
                    placeholder="Enter base price..."
                    required
                    min="0"
                  />
                </div>

                <div className="service-form-group">
                  <label>
                    <Tag size={18} />
                    Price Unit *
                  </label>
                  <select
                    name="priceUnit"
                    value={serviceForm.priceUnit}
                    onChange={handleFormChange}
                    required
                  >
                    <option value="hour">Per Hour</option>
                    <option value="service">Per Service</option>
                    <option value="day">Per Day</option>
                  </select>
                </div>
              </div> */}

              <div className="service-form-group">
                <label>
                  <Image size={18} />
                  Service Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
                {serviceForm.image && (
                  <div className="image-preview">
                    <img src={serviceForm.image} alt="Preview" />
                  </div>
                )}
              </div>

              <div className="service-form-checkboxes">
                {/* <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="featured"
                    checked={serviceForm.featured}
                    onChange={handleFormChange}
                  />
                  <Star size={16} />
                  Mark as Featured Service
                </label> */}

                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="status"
                    checked={serviceForm.status === 'active'}
                    onChange={(e) => setServiceForm(prev => ({
                      ...prev,
                      status: e.target.checked ? 'active' : 'inactive'
                    }))}
                  />
                  <ToggleRight size={16} />
                  Activate Service
                </label>
              </div>

              <div className="service-form-actions">
                <button 
                  type="button" 
                  className="service-cancel-btn"
                  onClick={() => {
                    setShowCreateModal(false);
                    setShowEditModal(false);
                  }}
                >
                  Cancel
                </button>
                <button type="submit" className="service-save-btn">
                  <Save size={18} />
                  {showEditModal ? 'Update Service' : 'Create Service'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View Service Modal */}
      {showViewModal && selectedService && (
        <div className="admin-modal-overlay" onClick={() => setShowViewModal(false)}>
          <div className="admin-view-service-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowViewModal(false)}>
              <X size={24} />
            </button>

            <img src={selectedService.image} alt={selectedService.name} className="view-service-image" />

            <div className="view-service-content">
              <div className="view-service-header">
                <div>
                  <h2>{selectedService.name}</h2>
                  <span className="view-category-badge">{selectedService.category}</span>
                </div>
                <div className="view-badges">
                  {/* {selectedService.featured && (
                    <span className="featured-tag">
                      <Star size={16} fill="#fbbf24" />
                      Featured
                    </span>
                  )} */}
                  <span className={`status-tag ${selectedService.status}`}>
                    {selectedService.status}
                  </span>
                </div>
              </div>

              <p className="view-description">{selectedService.description}</p>

              {/* <div className="view-info-grid">
                <div className="view-info-item">
                  <DollarSign size={18} />
                  <div>
                    <span className="info-label">Base Price</span>
                    <span className="info-value">Rs {selectedService.basePrice}/{selectedService.priceUnit}</span>
                  </div>
                </div>
                <div className="view-info-item">
                  <Clock size={18} />
                  <div>
                    <span className="info-label">Duration</span>
                    <span className="info-value">{selectedService.duration}</span>
                  </div>
                </div>
                <div className="view-info-item">
                  <Star size={18} />
                  <div>
                    <span className="info-label">Rating</span>
                    <span className="info-value">{selectedService.rating} ({selectedService.reviews} reviews)</span>
                  </div>
                </div>
                <div className="view-info-item">
                  <Calendar size={18} />
                  <div>
                    <span className="info-label">Created</span>
                    <span className="info-value">{new Date(selectedService.createdAt).toLocaleDateString()}</span>
                  </div>
                </div>
              </div> */}

              {/* <div className="view-stats-grid">
                <div className="view-stat-box">
                  <Briefcase size={24} />
                  <h3>{selectedService.totalBookings}</h3>
                  <p>Total Bookings</p>
                </div>
                <div className="view-stat-box">
                  <Users size={24} />
                  <h3>{selectedService.activeProviders}</h3>
                  <p>Active Providers</p>
                </div>
                <div className="view-stat-box">
                  <DollarSign size={24} />
                  <h3>Rs {selectedService.revenue.toLocaleString()}</h3>
                  <p>Total Revenue</p>
                </div>
              </div> */}

              <div className="view-actions">
                <button className="view-edit-btn" onClick={() => {
                  setShowViewModal(false);
                  handleEditService(selectedService);
                }}>
                  <Edit size={18} />
                  Edit Service
                </button>
                <button 
                  className="view-toggle-btn"
                  onClick={() => {
                    toggleServiceStatus(selectedService);
                    setShowViewModal(false);
                  }}
                >
                  {selectedService.status === 'active' ? (
                    <><ToggleLeft size={18} /> Deactivate</>
                  ) : (
                    <><ToggleRight size={18} /> Activate</>
                  )}
                </button>
                <button className="view-delete-btn" onClick={() => {
                  setShowViewModal(false);
                  handleDeleteService(selectedService);
                }}>
                  <Trash2 size={18} />
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Modal */}
      {showDeleteModal && selectedService && (
        <div className="admin-modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="admin-delete-modal" onClick={(e) => e.stopPropagation()}>
            <div className="delete-icon">
              <AlertCircle size={48} />
            </div>
            <h2>Delete Service?</h2>
            <p>Are you sure you want to delete <strong>{selectedService.name}</strong>? This action cannot be undone.</p>
            <div className="delete-actions">
              <button className="cancel-btn" onClick={() => setShowDeleteModal(false)}>
                Cancel
              </button>
              <button className="confirm-btn" onClick={confirmDelete}>
                <Trash2 size={18} />
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminServices;